import React from 'react';

function Footer() {
  return (
    <footer>
      &copy; 2025 Crawford Family Bank. All rights reserved.
    </footer>
  );
}

export default Footer;